import { ERROR_KINDS } from './components/GenerateAvatar';

export const DEFAULT_AVATAR_CREATION_ERROR = 'Something went wrong';

export const ERROR_TEXT_BY_KIND: Record<ERROR_KINDS, string> = {
    [ERROR_KINDS.InsufficientCreditsError]: 'Not enough credits',
    [ERROR_KINDS.DreamsInvalidPrompt]: 'Invalid prompt',
    [ERROR_KINDS.FaceError]: 'No face detected',
    [ERROR_KINDS.InvalidConsentError]: 'Consent and avatar footage must feature the same person',
    [ERROR_KINDS.CelebrityDetectedError]: 'Famous figure detected',
    [ERROR_KINDS.TextModerationError]: 'Content flagged for moderation',
    [ERROR_KINDS.TrainingValidationError]: 'Training error',
    [ERROR_KINDS.ExtremePoseDetected]: 'Extreme pose detected',
    [ERROR_KINDS.AlgoRequestError]: 'Training error',
    [ERROR_KINDS.TooManyRequests]: 'Too many requests',
};
